<template>
	<div class="bdreconciliation">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">BD交易对账</div>
					<div class="contentcard">
						<div style="font-size: 14px; font-weight: 700;">对账筛选</div>
						<a-divider dashed style="margin: 10px 0;" />
						<div>
							<div style="display: inline-block;margin-right: 40px;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;text-align: right;margin-right: 10px;">手机号</span>
								<a-input placeholder="请输入手机号" style="width: 260px" v-model="searchlist.phone_number" />
							</div>
							<div style="display: inline-block;margin-right: 40px;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;text-align: right;margin-right: 10px;">订单月份</span>
								<a-month-picker placeholder="Select month" :defaultValue="moment(searchlist.month)" @change="onMonthChange" />
							</div>
							<div style="display: inline-block;margin-right: 40px;">
								<span style="font-size: 14px; font-weight: 700;display: inline-block;text-align: right;margin-right: 10px;">结算状态</span>
								<a-select v-model="searchlist.status" style="width: 120px">
									<a-select-option value="all">
										全部
									</a-select-option>
									<a-select-option value="unclear">
										未结算
									</a-select-option>
									<a-select-option value="clear">
										已结算
									</a-select-option>
								</a-select>
							</div>
							<a-button type="primary" style="width: 96px;" @click="onSearchBD">搜索</a-button>
						</div>
					</div>
					<div class="contentcard" style="margin-bottom: 0px;padding-bottom: 70px;">
						<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
							<a-col :span="2" style="text-align: center;">微信昵称</a-col>
							<a-col :span="2" style="text-align: center;">微信头像</a-col>
							<a-col :span="3" style="text-align: center;">手机号码</a-col>
							<a-col :span="3" style="text-align: center;">交易月份</a-col>
							<a-col :span="4" style="text-align: center;">结算状态</a-col>
							<a-col :span="4" style="text-align: center;">操作</a-col>
						</a-row>
						<div v-if="issearch" style="text-align: center;border-radius: 4px;padding: 11px 0 0 0;">
							<a-spin />
						</div>
						<div v-if="(!bdlist.length)&&(!issearch)">
							<a-alert message="查询结果为空" banner type="info" />
						</div>
						<div style="color: #666;font-size: 14px;" v-for="(bd,index) in bdlist" :key="index">
							<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px;border-top: none;min-height: 60px;padding: 5px 0;">
								<a-col :span="2" style="text-align: center;">{{bd.nick_name}}</a-col>
								<a-col :span="2" style="text-align: center;"><img :src="bd.avatar_url" height="56"></a-col>
								<a-col :span="3" style="text-align: center;">{{bd.phone_number}}</a-col>
								<a-col :span="3" style="text-align: center;">{{moment(searchlist.month).format('MMMM')}}</a-col>
								<a-col :span="4" style="text-align: center;">{{reconciliation_status(bd.reconciliation_status)}}</a-col>
								<a-col :span="4" style="text-align: center;">
									<a-button type="primary" ghost size="small" style="width: 96px;font-size: 12px;" @click="gototrade(bd.id)">去对账</a-button>
								</a-col>
							</a-row>
						</div>
						<div style="float: right;position: relative;bottom: -18px;">
							<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize" :total="bdsum"
							 showQuickJumper @change="pageChange" />
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	export default {

		data() {
			return {
				current: ['bdreconciliation'],
				openKeys: ['bdmodule'],
				startpage: this.$route.query.startpage || 0,
				endpage: this.$route.query.endpage || 10,
				pageSize: Number(this.$route.query.pageSize) || 10,
				bdlist: [],
				bdsum: 0,
				issearch: false,
				searchlist: {
					phone_number: null,
					month: new Date(),
					status: "all",
				}
			}
		},
		created: function() {
			if (this.$route.query.searchlist) {
				this.searchlist = JSON.parse(this.$route.query.searchlist)
			}
			this.initialize();
		},
		methods: {
			moment,
			initialize() {
				var self = this;
				this.issearch = true;
				this.bdlist = [];
				this.bdsum = 0;
				var params = {
					searchlist: JSON.stringify(this.searchlist),
					startpage: this.startpage,
					pageSize: this.pageSize
				};
				this.$axios.get('/bd/getreconciliationlist', {
					params: params
				}).then(function(res) {
					self.bdlist = res.data.bdlist;
					self.bdsum = res.data.bdsum;
					self.issearch = false;
				});
			},
			onShowSizeChange(current, pageSize) {
				this.pageSize = pageSize;
				this.startpage = this.pageSize * (current - 1);
				this.endpage = this.pageSize * current;
				this.initialize();
				this.$router.push({
					name: 'bdreconciliation',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist),
					}
				})

			},
			pageChange(pageNumber) {
				this.startpage = this.pageSize * (pageNumber - 1);
				this.endpage = this.pageSize * pageNumber;
				this.initialize();
				this.$router.push({
					name: 'bdreconciliation',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist),
					}
				})
			},
			onSearchBD() {
				var self = this;
				this.startpage = 0;
				this.endpage = this.pageSize;
				// this.pageSize = 10;
				this.initialize();
				this.$router.push({
					name: 'bdreconciliation',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist),
					}
				})
			},
			onMonthChange(date, dateString) {
				this.searchlist.month = dateString;
			},
			reconciliation_status(reconciliation_status) {
				switch (reconciliation_status) {
					case 'no_shopkeeper':
						return '该BD暂无绑定店主'
						break;
					case 'no_success_trade':
						return '该BD绑定店主暂无交易'
						break;
					case 'is_clear':
						return '已结算'
						break;
					case 'have_unclear':
						return '未结算'
						break;
				}
			},
			gototrade(id){
				this.$router.push({
					name: 'reconciliation_trade',
					query: {
						id: id,
					}
				})
			}
		}

	};
</script>

<style>
	.bdreconciliation .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// index.vue?29e0c86a